// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import type { RootState } from 'Store';

// Reads for the Khora conversation state (mirrors Features/order/orderSelectors).
export const getChatMessages = (state: RootState) => state.chatbot.messages;
export const getChatLoading = (state: RootState) => state.chatbot.loading;
export const getChatProgress = (state: RootState) => state.chatbot.progress;
export const getChatError = (state: RootState) => state.chatbot.error;
export const getSessionStale = (state: RootState) => state.chatbot.sessionStale;
